import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { sendPageView } from '../ga/index';
export const PageAnalytics = () => {
    const { basePath, locale, asPath } = useRouter();
    const DEFAULT_LOCALE = 'en-US';
    const pathLocale = locale === DEFAULT_LOCALE ? '' : `/${locale}`;
    const path = `${basePath}${pathLocale}${asPath === '/' ? '' : asPath}` || '/';
    useEffect(() => {
        sendPageView(path);
    }, [path]);
    return null;
};
//# sourceMappingURL=PageAnalytics.js.map